/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreatePayload,
  SubTransactionDto,
  UpdateSubTransactionDto,
  UpsertSubTransactionsPayload,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSubTransactionController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-sub-transaction-controller
   * @name GetSubTransactions
   * @request GET:/api/v1/transactions/{flowId}/sub-transactions
   */
  getSubTransactions = (flowId: string, params: RequestParams = {}) =>
    this.http.request<SubTransactionDto[], any>({
      path: `/v1/transactions/${flowId}/sub-transactions`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSubTransactionsPath = '/v1/transactions/${flowId}/sub-transactions'
  static getSubTransactionsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-sub-transaction-controller
   * @name UpsertSubTransactions
   * @request PUT:/api/v1/transactions/{flowId}/sub-transactions
   */
  upsertSubTransactions = (
    flowId: string,
    data: UpsertSubTransactionsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/transactions/${flowId}/sub-transactions`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static upsertSubTransactionsPath = '/v1/transactions/${flowId}/sub-transactions'
  static upsertSubTransactionsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-sub-transaction-controller
   * @name Create
   * @request POST:/api/v1/transactions/{flowId}/sub-transactions
   */
  create = (flowId: string, data: CreatePayload, params: RequestParams = {}) =>
    this.http.request<SubTransactionDto[], any>({
      path: `/v1/transactions/${flowId}/sub-transactions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v1/transactions/${flowId}/sub-transactions'
  static createMethod = 'POST'
  /**
   * No description
   *
   * @tags api-sub-transaction-controller
   * @name DeleteAllSubTransactions
   * @request DELETE:/api/v1/transactions/{flowId}/sub-transactions
   */
  deleteAllSubTransactions = (flowId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/transactions/${flowId}/sub-transactions`,
      method: 'DELETE',
      ...params,
    })

  static deleteAllSubTransactionsPath = '/v1/transactions/${flowId}/sub-transactions'
  static deleteAllSubTransactionsMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-sub-transaction-controller
   * @name UpdateSubTransaction
   * @request PUT:/api/v1/transactions/{flowId}/sub-transactions/{id}
   */
  updateSubTransaction = (
    id: string,
    flowId: string,
    data: UpdateSubTransactionDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/transactions/${flowId}/sub-transactions/${id}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateSubTransactionPath = '/v1/transactions/${flowId}/sub-transactions/${id}'
  static updateSubTransactionMethod = 'PUT'
}
